import { render, staticRenderFns } from "./HistoryMain.vue?vue&type=template&id=7dbc57c8&scoped=true&"
import script from "./HistoryMain.vue?vue&type=script&lang=js&"
export * from "./HistoryMain.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMain.vue?vue&type=style&index=0&id=7dbc57c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc57c8",
  null
  
)

export default component.exports